import React from 'react';
import { IconProps } from './types';

const PlayArrow: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 12L5.5 21.5263L5.5 2.47372L22 12Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default PlayArrow;
